/**
 * Shared helpers for bulk-import UX across L0 raw materials, L1 items and cooked recipes.
 * Emits blank templates and post-import status reports as browser CSV downloads.
 */

const escape = (v) => {
  if (v == null) return "";
  const s = String(v);
  return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
};

const download = (filename, csv) => {
  const blob = new Blob(["\uFEFF" + csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
};

export const downloadTemplate = (filename, columns, sampleRows = []) => {
  const rows = [columns.join(","), ...sampleRows.map((r) => r.map(escape).join(","))];
  download(filename, rows.join("\n"));
};

/**
 * Build and download an import status report from the backend response.
 * The backend must return `row_status: [{row, name, status, message}]`.
 * status ∈ {created, updated, skipped, error}
 */
export const downloadImportReport = (filenamePrefix, result) => {
  const rs = result?.row_status || [];
  if (rs.length === 0) return;
  // IST timestamp: DD-MM-YYYY_HH-MM-SS_IST
  const now = new Date();
  const ist = new Date(now.getTime() + (now.getTimezoneOffset() + 330) * 60000);
  const pad = (n) => String(n).padStart(2, "0");
  const stamp = `${pad(ist.getDate())}-${pad(ist.getMonth() + 1)}-${ist.getFullYear()}_${pad(ist.getHours())}-${pad(ist.getMinutes())}-${pad(ist.getSeconds())}_IST`;
  const header = ["Row", "Name / SKU", "Status", "Details"];
  const skipped = rs.filter((r) => r.status === "skipped" || r.status === "error").length;
  const body = rs.map((r) => [r.row ?? "", r.name || "", (r.status || "").toUpperCase(), r.message || ""]);
  const summary = [
    ["#", "Summary", "", ""],
    ["", `Created: ${result?.created ?? 0}`, "", ""],
    ["", `Updated: ${result?.updated ?? 0}`, "", ""],
    ["", `Skipped/Errored: ${skipped}`, "", ""],
    ["", "", "", ""],
  ];
  const csv = [header.join(","), ...summary.map((r) => r.map(escape).join(",")), ...body.map((r) => r.map(escape).join(","))].join("\n");
  download(`${filenamePrefix}_import_report_${stamp}.csv`, csv);
};

// Consistent toast message used across all three import flows.
export const importToastMessage = (result) => {
  const rs = result?.row_status || [];
  const skipped = rs.filter((r) => r.status === "skipped" || r.status === "error").length;
  return `${result?.created ?? 0} created, ${result?.updated ?? 0} updated, ${skipped} skipped`;
};
